import React, {Component} from 'react'
import getMuiTheme from 'material-ui/styles/getMuiTheme'

export const weeklyDayPickerClassNames = {
    container : '',
    prevWeekArrow: '',
    nextWeekArrow: '',
    dayBox: '',
    dayCircleContainer: '',
    dayCicle:'',
    dayCircleTodayText: '',
    dayCircleUnavailable: '',
    dayCircleUnavailableText: '',
    dayCicleSelected: '',
}

export const cardStyles = {
  borderStyle: 'solid',
  borderWidth: '1px',
  borderColor: '#660066',
  padding: '10px',
  width: '100%',
}

/** Onboard.js */
export const titleStyle = {
  fontSize: '16px',
  lineHeight: '24px',
  color: '#171717'
}
export const subtitleStyle = {fontSize: '14px',
  lineHeight: '18px',
  color: '#111111'
}

/** SkipIt.js */
export const SearchAddress = () => (
  <div className="bold">
    <i className="material-icons mapper">search</i>
    &nbsp;&nbsp;&nbsp;search address..
  </div>
)
export const styles = {
  headline: {
    fontSize: 24,
    paddingTop: 16,
    marginBottom: 12,
    fontWeight: 400,
  },
  checkbox: {
    marginBottom: 16,
  },
}
export const muiTheme = getMuiTheme({
  palette: {
    primary1Color: '#251B32',
    primary2Color: '#F5F5F5',
    primary3Color: '#F5F5F5',
    accent1Color: '#F5F5F5',
    accent2Color: '#F5F5F5',
    accent3Color: '#C5B358',
    alternateTextColor: '#DCA3AC',
  },
})



// WEBPACK FOOTER //
// ./src/Constants.js